export type Platform = "Web" | "Electron";
export type Channel = "Stable" | "Early Access" | "Localhost";

export function getPlatform(): Platform {
  if (typeof window === "undefined") return "Web";
  return window.electronAPI?.isElectron ? "Electron" : "Web";
}

export function getChannel(): Channel {
  if (typeof window === "undefined") return "Localhost";
  const host = window.location.hostname;
  if (host === "chat.spoke.com") return "Stable";
  if (host === "beta.chat.spoke.com") return "Early Access";
  return "Localhost";
}
